import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {  getListTradeBaseOnPeriodAction } from "../actions";
import { listTradeBaseOnPeriodSelector, } from "../store/slice/trade";

/**
 *
 * @returns {[{
 *  instruments: (import("../..").IInstrument)[],
 *  loading: boolean,
 *  error: object,
 * }, {
 *  getInstruments: () => void
 * }]}
 */
const useListTradeBaseOnPeriod = () => {
  const dispatch = useDispatch();

  const getListTradeBaseOnPeriod = useCallback(queryData => dispatch(getListTradeBaseOnPeriodAction(queryData)), [dispatch]);

  const listTradeBaseOnPeriodState = useSelector(listTradeBaseOnPeriodSelector);

  return  { getListTradeBaseOnPeriod, listTradeBaseOnPeriodState };
};

/**
 *
 * @returns {[{
 *  selectedInstrument: Record<string, (import("../..").IInstrument)>,
 * }, {
 * onChangeSelectedInstrument: (id: (import("../..").IInstrument['instrumentId'])) => void
 * }]}}
 */
// export const useInstrument = () => {
//   const selectedInstrument = useSelector(selectedInstrumentSelector);
//   const dispatch = useDispatch();
//   const onChangeSelectedInstrument = useCallback(
//     id => {
//       // console.log('id', id);
//       dispatch(setSelectedInstrument(id));
//     },
//     [dispatch]
//   );
//   return [{ selectedInstrument }, { onChangeSelectedInstrument }];
// };

export default useListTradeBaseOnPeriod;
